import {getCommunityType} from "../utils/getCommunityType";

export function removeProst(id, commentId, shopUserId, commentComment) {
    let container = $("#" + id + ".timeline_entry");
    let tmpCommunityType = getCommunityType(container);
    $.ajax({
        type: "POST",
        url: "/module/community/ajax.php?action=remove_prost",
        datatype: "json",
        data: {
            "ajax_call_id": id,
            "ajax_call_comment_id": commentId,
            "ajax_call_shop_user_id": shopUserId,
            "ajax_call_community_type": tmpCommunityType,
            "ajax_call_community_type_global": communityType
        },
        success: function (output) {
            let prostLink = container.find(".un_prost_link:first");
            let commentContainer = $(".display_comment#comment_" + commentId);
            if (commentComment) {
                commentContainer = $(".display_comment_comment#comment_comment_" + commentId);
                commentContainer.find('.prost_count_comment_comment').text(output);
                prostLink = commentContainer.find(".un_prost_link");
            } else if (commentId !== 0) {
                commentContainer.find('.prost_count_comment').text(output);
                prostLink = commentContainer.find(".un_prost_link");
            } else {
                container.find(".prost_count").text(output);
            }

            prostLink.removeClass("un_prost_link");
            prostLink.removeClass("active");
            prostLink.addClass("prost_link");
        }
    });
}